import { useState } from 'react';

const AddEditTrayManagementPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showAddEditTrayManagementPopup, setShowAddEditTrayManagementPopup] =
      useState<boolean>(false);

    const addTrayToggleHandler = () => {
      setShowAddEditTrayManagementPopup(!showAddEditTrayManagementPopup);
    };

    return (
      <Component
        showAddTrayManagementPopup={showAddEditTrayManagementPopup}
        addTrayToggleHandler={addTrayToggleHandler}
        {...props}
      />
    );
  };

export default AddEditTrayManagementPopupHOC;
